<div class="row" [ngStyle]="{ 'padding-top': '10px' }">
  <div class="twelve columns">
    @if (proxyEnabled) {
      <div>
        @for (proxyUser of proxyUsers; track proxyUser) {
          <button [ngStyle]="{ 'display' : 'block' }" attr.user={{proxyUser}} soho-menu-button menu="actor-popupmenu" [autoFocus]="true" trigger="click" (beforeopen)="onBeforeOpen($event)" (selected)="onSelected($event)">{{proxyUser}}</button><br>
        }

        <ul soho-popupmenu id="actor-popupmenu">
          @for (proxyWebApp of proxyWebApps; track proxyWebApp) {
            <li soho-popupmenu-item><a soho-popupmenu-label attr.webApp="{{proxyWebApp.proxyWebApp}}">{{proxyWebApp.proxyWebApp}}</a></li>
          }
        </ul>
      </div>
    }
    @if (proxyMode) {
      <div>
        @for (proxyResetUrl of proxyResetUrls; track proxyResetUrl) {
          <span [ngStyle]="{ 'display' : 'block' }"><a href="#" class="hyperlink" (click)="onSwitchToProxyClicked(proxyResetUrl.proxyResetWebAppUrl)">{{proxyResetUrl.proxyResetWebApp}}</a></span><br>
        }
      </div>
    }
  </div>
</div>
<div class="row" [ngStyle]="{ 'padding-top': '10px' }">
  @if (proxyManagementLink) {
    <div class="twelve columns" style="margin-left: 0px; text-align: left;">
      <label [ngStyle]="{ 'display' : 'inline' }">{{ 'ProxyManagementMessage' | translate }}</label><br>
        <a (click)="onProxyManagementLinkClicked(proxyManagementLink)" class="hyperlink"><span>{{proxyManagementLinkMessage}}</span></a>
    </div>
  }
</div>